// src/main/RentReminder.js

import React, { useState, useEffect } from 'react';
import {
    Container,
    Typography,
    Button,
    Paper,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Box,
    Chip,
    Grid,
    Slide,
    MenuItem,
    InputLabel,
    FormControl,
    Select,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TablePagination,
    Divider,
    useTheme,
    InputAdornment,
    Menu,
    Tooltip,
    Card,
    CardContent,
    CardActions,
    Tabs,
    Tab,
    Avatar,
    LinearProgress,
    Stack,
    Alert,
    Snackbar,
    FormControlLabel,
    Switch,
    Stepper,
    Step,
    StepLabel,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Breadcrumbs,
    Link,
    Fab,
    Zoom,
    Badge,
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Timeline,
    TimelineItem,
    TimelineSeparator,
    TimelineDot,
    TimelineConnector,
    TimelineContent,
    TimelineOppositeContent,
    StepIcon,
    StepConnector,
    styled,
    Rating,
    CircularProgress,
    Backdrop,
    LinearProgress as MuiLinearProgress,
    ToggleButton,
    ToggleButtonGroup
} from '@mui/material';
import {
    Delete,
    Search,
    Add as AddIcon,
    Close as CloseIcon,
    Filter as FilterIcon,
    Refresh as RefreshIcon,
    Edit as EditIcon,
    Visibility as ViewIcon,
    Apartment as ApartmentIcon,
    Home as HomeIcon,
    LocationOn,
    Business,
    FormatListNumbered,
    PictureAsPdf,
    TableChart,
    GetApp,
    Print,
    MeetingRoom,
    Build,
    CheckCircle,
    Cancel,
    People,
    AttachMoney,
    TrendingUp,
    TrendingDown,
    MoreVert,
    Dashboard as DashboardIcon,
    List as ListIcon,
    Store as StoreIcon,
    Phone,
    Email,
    Person,
    Assignment,
    Map as MapIcon,
    ViewModule,
    ViewList,
    ExpandMore,
    NavigateNext,
    AddCircleOutline,
    RemoveCircleOutline,
    Warning,
    CheckBox,
    RadioButtonChecked,
    BedroomParent,
    Bathtub,
    SquareFoot,
    Kitchen,
    LocalParking,
    Elevator,
    Security,
    Wifi,
    AcUnit,
    LocalLaundryService,
    Pool,
    EventNote,
    Receipt,
    History,
    MoveToInbox,
    ExitToApp,
    Gavel,
    VerifiedUser,
    CreditCard,
    CalendarToday,
    Description,
    Note,
    AttachFile,
    CloudUpload,
    Key,
    AssignmentInd,
    HowToReg,
    PersonAdd,
    SwapHoriz,
    CheckCircleOutline,
    ReceiptLong,
    QrCodeScanner,
    AccountBalance,
    PhoneAndroid,
    CreditCard as CreditCardIcon,
    LocalAtm,
    Print as PrintIcon,
    Download,
    VisibilityOff,
    Verified,
    Pending,
    Error as ErrorIcon,
    Receipt as ReceiptIcon,
    NotificationsActive,
    NotificationsNone,
    Schedule,
    Email as EmailIcon,
    Sms,
    Send,
    PlayArrow,
    Pause,
    Settings,
    Rule,
    History as HistoryIcon,
    Timeline as TimelineIcon,
    Today,
    DateRange
} from '@mui/icons-material';
import { motion } from 'framer-motion';
import useCustomToast from '../../hooks/useToast';
import {
    APIPropertyList,
    APIApartmentList,
    APIFloorUnitList,
    APITenantList,
    APIAssignmentList,
    APIReminderRuleList,
    APIReminderRuleStore,
    APIReminderRuleUpdate,
    APIReminderRuleDelete,
    APIReminderLogList,
    APIReminderLogExportExcel,
    APIReminderLogExportPDF,
    APIReminderLogPrint,
    APIReminderStats,
    APIReminderSendNow,
    APIReminderTestSend
} from '../../apiServices/APIs';
import { formatCreatedAtDate, recordsCount, recordsPerPage } from '../../utils/helpers';
import { getUserDetails } from '../../utils/helpers';
import { apiService } from '../../apiServices/ApiService';
import ErrorState from '../../components/ErrorrState';
import LoadingState from '../../components/LoadingState';
import { usePermission } from '../../hooks/usePermission';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const RentReminder = () => {
    const theme = useTheme();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const showToast = useCustomToast();
    const [updateId, setUpdateId] = useState('');
    const [postStatus, setPostStatus] = useState('ADD');
    const [exportAnchorEl, setExportAnchorEl] = useState(null);
    const [pageState, setPageState] = useState({
        rules: [],
        logs: []
    });
    const [activeTab, setActiveTab] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(recordsPerPage);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [statistics, setStatistics] = useState(null);
    const [tenants, setTenants] = useState([]);
    const [assignments, setAssignments] = useState([]);
    const [sendingNow, setSendingNow] = useState(false);
    const [testDialogOpen, setTestDialogOpen] = useState(false);
    const [testTenantId, setTestTenantId] = useState('');
    const [testMessage, setTestMessage] = useState('');

    // Reminder type options
    const reminderTypeOptions = [
        { id: 'before_due', name: 'Before Due Date', icon: <Schedule />, color: 'info', defaultOffset: -3 },
        { id: 'on_due', name: 'On Due Date', icon: <Today />, color: 'warning', defaultOffset: 0 },
        { id: 'after_due', name: 'After Due Date', icon: <DateRange />, color: 'error', defaultOffset: 3 }
    ];

    // Channel options
    const channelOptions = [
        { id: 'email', name: 'Email', icon: <EmailIcon />, color: 'primary' },
        { id: 'sms', name: 'SMS', icon: <Sms />, color: 'success' }
    ];

    // Delivery status options
    const deliveryStatusOptions = [
        { id: 'sent', name: 'Sent', color: 'success', icon: <CheckCircle /> },
        { id: 'failed', name: 'Failed', color: 'error', icon: <ErrorIcon /> },
        { id: 'pending', name: 'Pending', color: 'warning', icon: <Pending /> }
    ];

    // Form data for Reminder Rule
    const [formData, setFormData] = useState({
        reminder_type: 'before_due',
        days_offset: -3,
        message_template: '',
        send_email: true,
        send_sms: false,
        is_active: true,
        reminder_time: '09:00',
        notes: ''
    });

    const [filters, setFilters] = useState({
        reminder_type: '',
        is_active: '',
        channel: '',
        delivery_status: '',
        date_from: '',
        date_to: '',
        tenant_id: ''
    });

    const [errors, setErrors] = useState({
        reminder_type: false,
        message_template: false
    });

    // State for dialogs
    const [filterOptions, setFilterOptions] = useState(false);
    const [openAdd, setOpenAdd] = useState(false);
    const [openView, setOpenView] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

    // Use the updated permission hook
    const { hasPermission, loading: permissionLoading } = usePermission();

    useEffect(() => {
        apiService.setToastFunction(showToast);
        fetchTenants();
        fetchAssignments();
        fetchRules();
        fetchLogs();
        fetchStatistics();
    }, [showToast]);

    // Fetch tenants
    const fetchTenants = async () => {
        try {
            const userBranchId = getUserDetails("branchId");
            const result = await apiService.list(userBranchId, APITenantList, { tenant_status: 'active' });
            if (result.success) {
                setTenants(Array.isArray(result.data) ? result.data : []);
            }
        } catch (error) {
            console.error("Error fetching tenants:", error);
            setTenants([]);
        }
    };

    // Fetch assignments for rent due dates
    const fetchAssignments = async () => {
        try {
            const userBranchId = getUserDetails("branchId");
            const result = await apiService.list(userBranchId, APIAssignmentList, { assignment_status: 'active' });
            if (result.success) {
                setAssignments(Array.isArray(result.data) ? result.data : []);
            }
        } catch (error) {
            console.error("Error fetching assignments:", error);
            setAssignments([]);
        }
    };

    // Fetch reminder rules
    const fetchRules = async () => {
        setLoading(true);
        try {
            const userBranchId = getUserDetails("branchId");
            const result = await apiService.list(userBranchId, APIReminderRuleList);
            if (result.success) {
                setPageState(prev => ({
                    ...prev,
                    rules: Array.isArray(result.data) ? result.data : []
                }));
            }
        } catch (error) {
            console.error("Error fetching rules:", error);
        } finally {
            setLoading(false);
        }
    };

    // Fetch reminder logs
    const fetchLogs = async () => {
        try {
            const userBranchId = getUserDetails("branchId");
            const result = await apiService.list(userBranchId, APIReminderLogList);
            if (result.success) {
                setPageState(prev => ({
                    ...prev,
                    logs: Array.isArray(result.data) ? result.data.reverse() : []
                }));
            }
        } catch (error) {
            console.error("Error fetching logs:", error);
        }
    };

    // Fetch statistics
    const fetchStatistics = async () => {
        try {
            const userBranchId = getUserDetails("branchId");
            const result = await apiService.listStats(userBranchId, APIReminderStats);
            if (result.success && result.data) {
                setStatistics(result.data);
            }
        } catch (error) {
            console.error("Error fetching statistics:", error);
        }
    };

    // Export handlers
    const handleExportClick = (event) => { setExportAnchorEl(event.currentTarget); };
    const handleExportClose = () => { setExportAnchorEl(null); };
    
    const handlePrintLog = async (record) => {
        if (!hasPermission('EXPORT')) {
            showToast("Permission Denied", "You don't have permission to print reminder logs", "error");
            return;
        }
        
        try {
            const formDataToSend = new FormData();
            formDataToSend.append('print_id', record.id);
            formDataToSend.append('user_name', getUserDetails("userName"));
            formDataToSend.append('branch_id', getUserDetails("branchId"));
            formDataToSend.append('user_id', getUserDetails("Id"));
            const result = await apiService.print(APIReminderLogPrint, formDataToSend);

            if (result && result.success) {
                showToast("Success", "PDF file generated successfully", "success");
            } else {
                showToast("Error", result.message || "Failed to generate PDF file", "error");
            }
        } catch (error) {
            console.error("Print error:", error);
            showToast("Error", "Failed to generate PDF file", "error");
        }
    };
    
    const handleExportExcel = async () => {
        if (!hasPermission('EXPORT')) {
            showToast("Permission Denied", "You don't have permission to export reminder logs", "error");
            handleExportClose();
            return;
        }
        
        try {
            handleExportClose();
            showToast("Processing", "Preparing Excel export...", "info");
            const formDataToSend = new FormData();
            formDataToSend.append('branch_id', getUserDetails("branchId"));
            formDataToSend.append('user_id', getUserDetails("Id"));
            const result = await apiService.exportToExcel(APIReminderLogExportExcel, formDataToSend);
            if (result && result.success) {
                showToast("Success", "Excel file downloaded successfully", "success");
            } else {
                showToast("Error", result.message || "Failed to export Excel file", "error");
            }
        } catch (error) {
            console.error('Excel export error:', error);
            showToast("Error", error.message || "Failed to export Excel file", "error");
        }
    };

    const handleExportPDF = async () => {
        if (!hasPermission('EXPORT')) {
            showToast("Permission Denied", "You don't have permission to export reminder logs", "error");
            handleExportClose();
            return;
        }
        
        try {
            handleExportClose();
            showToast("Processing", "Preparing PDF export...", "info");

            const formDataToSend = new FormData();
            formDataToSend.append('branch_id', getUserDetails("branchId"));
            formDataToSend.append('user_name', getUserDetails("userName"));
            formDataToSend.append('user_id', getUserDetails("Id"));
            const result = await apiService.exportToPDF(APIReminderLogExportPDF, formDataToSend);

            if (result && result.success) {
                showToast("Success", "PDF file downloaded successfully", "success");
            } else {
                showToast("Error", result.message || "Failed to export PDF file", "error");
            }
        } catch (error) {
            console.error('PDF export error:', error);
            showToast("Error", error.message || "Failed to export PDF file", "error");
        }
    };

    // Send reminder now
    const handleSendNow = async () => {
        if (!hasPermission('EDIT')) {
            showToast("Permission Denied", "You don't have permission to send reminders", "error");
            return;
        }

        setSendingNow(true);
        try {
            const formDataToSend = new FormData();
            formDataToSend.append('user_id', getUserDetails("Id"));
            formDataToSend.append('branch_id', getUserDetails("branchId"));

            const result = await apiService.create(APIReminderSendNow, formDataToSend);
            if (result && result.success) {
                showToast("Success", result.message, "success");
                fetchLogs();
                fetchStatistics();
            }
        } catch (error) {
            console.error("Send now error:", error);
            showToast("Error", "Failed to send reminders", "error");
        } finally {
            setSendingNow(false);
        }
    };

    // Test reminder
    const handleTestSend = async () => {
        if (!testTenantId) {
            showToast("Validation Error", "Please select a tenant", "warning");
            return;
        }

        try {
            const formDataToSend = new FormData();
            formDataToSend.append('user_id', getUserDetails("Id"));
            formDataToSend.append('branch_id', getUserDetails("branchId"));
            formDataToSend.append('tenant_id', testTenantId);
            formDataToSend.append('test_message', testMessage);

            const result = await apiService.create(APIReminderTestSend, formDataToSend);
            if (result && result.success) {
                showToast("Success", result.message, "success");
                handleCloseTestDialog();
                fetchLogs();
                fetchStatistics();
            }
        } catch (error) {
            console.error("Test send error:", error);
            showToast("Error", "Failed to send test reminder", "error");
        }
    };

    // Filter logs
    const filteredLogs = pageState.logs.filter(record => {
        const matchesSearch = searchTerm === '' ||
            record.tenant_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            record.tenant_phone?.includes(searchTerm) ||
            record.message_sent?.toLowerCase().includes(searchTerm.toLowerCase());

        const matchesStatus = !filters.delivery_status || 
            record.delivery_status === filters.delivery_status;

        const matchesChannel = !filters.channel || 
            record.channel === filters.channel;

        const matchesTenant = !filters.tenant_id || 
            record.tenant_id?.toString() === filters.tenant_id;

        let matchesDate = true;
        if (filters.date_from && record.reminder_date) {
            matchesDate = matchesDate && record.reminder_date >= filters.date_from;
        }
        if (filters.date_to && record.reminder_date) {
            matchesDate = matchesDate && record.reminder_date <= filters.date_to;
        }

        return matchesSearch && matchesStatus && matchesChannel && matchesTenant && matchesDate;
    });

    // Filter rules
    const filteredRules = pageState.rules.filter(rule => {
        const matchesType = !filters.reminder_type || 
            rule.reminder_type === filters.reminder_type;

        const matchesActive = filters.is_active === '' || 
            (filters.is_active === 'active' ? rule.is_active : !rule.is_active);

        return matchesType && matchesActive;
    });

    // Pagination handlers
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // Dialog handlers
    const handlefilterOptions = () => setFilterOptions(true);
    const handleCloseOptions = () => setFilterOptions(false);

    const handleOpenAdd = () => {
        if (!hasPermission('ADD')) {
            showToast("Permission Denied", "You don't have permission to add reminder rules", "error");
            return;
        }

        setPostStatus("ADD");
        setFormData({
            reminder_type: 'before_due',
            days_offset: -3,
            message_template: getDefaultMessageTemplate('before_due'),
            send_email: true,
            send_sms: false,
            is_active: true,
            reminder_time: '09:00',
            notes: ''
        });
        setErrors({
            reminder_type: false,
            message_template: false
        });
        setOpenAdd(true);
    };

    const handleCloseAdd = () => {
        setOpenAdd(false);
    };

    const handleOpenView = (record) => {
        setSelectedRecord(record);
        setOpenView(true);
    };

    const handleCloseView = () => {
        setOpenView(false);
    };

    const handleOpenEdit = (record) => {
        if (!hasPermission('EDIT')) {
            showToast("Permission Denied", "You don't have permission to edit reminder rules", "error");
            return;
        }

        setSelectedRecord(record);
        setUpdateId(record.id);
        setPostStatus("UPDATE");

        setFormData({
            reminder_type: record.reminder_type || 'before_due',
            days_offset: record.days_offset || -3,
            message_template: record.message_template || '',
            send_email: record.send_email || false,
            send_sms: record.send_sms || false,
            is_active: record.is_active || false,
            reminder_time: record.reminder_time || '09:00',
            notes: record.notes || ''
        });
        setOpenAdd(true);
    };

    const handleOpenDelete = (record) => {
        if (!hasPermission('DELETE')) {
            showToast("Permission Denied", "You don't have permission to delete reminder rules", "error");
            return;
        }

        setSelectedRecord(record);
        setUpdateId(record.id);
        setPostStatus("DELETE");
        setOpenDelete(true);
    };

    const handleCloseDelete = () => {
        setOpenDelete(false);
    };

    const handleOpenTestDialog = () => {
        setTestTenantId('');
        setTestMessage('');
        setTestDialogOpen(true);
    };

    const handleCloseTestDialog = () => {
        setTestDialogOpen(false);
    };

    // Form handlers
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        setErrors(prev => ({
            ...prev,
            [name]: false
        }));

        if (name === 'reminder_type') {
            const selectedType = reminderTypeOptions.find(t => t.id === value);
            const defaultOffset = selectedType?.defaultOffset || 0;
            setFormData(prev => ({
                ...prev,
                [name]: value,
                days_offset: defaultOffset,
                message_template: getDefaultMessageTemplate(value)
            }));
            return;
        }

        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const getDefaultMessageTemplate = (type) => {
        const templates = {
            before_due: "Dear {tenant_name},\n\nThis is a friendly reminder that your rent of {rent_amount} for {apartment_number} is due in {days} days on {due_date}. Please ensure timely payment to avoid late fees.\n\nThank you for your prompt attention.\n\nBest regards,\n{company_name}",
            on_due: "Dear {tenant_name},\n\nYour rent of {rent_amount} for {apartment_number} is due TODAY ({due_date}). Please make your payment as soon as possible.\n\nThank you for your prompt attention.\n\nBest regards,\n{company_name}",
            after_due: "Dear {tenant_name},\n\nThis is a reminder that your rent of {rent_amount} for {apartment_number} was due on {due_date} and is now {days} days overdue. Please make the payment immediately to avoid additional late fees.\n\nBest regards,\n{company_name}"
        };
        return templates[type] || templates.before_due;
    };

    // Filter handlers
    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const clearFilters = () => {
        setFilters({
            reminder_type: '',
            is_active: '',
            channel: '',
            delivery_status: '',
            date_from: '',
            date_to: '',
            tenant_id: ''
        });
        setSearchTerm('');
        handleCloseOptions();
    };

    const applyFilters = () => {
        handleCloseOptions();
    };

    const validateForm = () => {
        if (!formData.reminder_type) {
            showToast("Validation Error", "Reminder type is required", "warning");
            return false;
        }
        if (!formData.message_template?.trim()) {
            showToast("Validation Error", "Message template is required", "warning");
            return false;
        }
        if (!formData.send_email && !formData.send_sms) {
            showToast("Validation Error", "Please select at least one delivery channel", "warning");
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (postStatus === "ADD" && !hasPermission('ADD')) {
            showToast("Permission Denied", "You don't have permission to add reminder rules", "error");
            return;
        }
        
        if (postStatus === "UPDATE" && !hasPermission('EDIT')) {
            showToast("Permission Denied", "You don't have permission to update reminder rules", "error");
            return;
        }
        
        if (postStatus === "DELETE" && !hasPermission('DELETE')) {
            showToast("Permission Denied", "You don't have permission to delete reminder rules", "error");
            return;
        }
        
        if (postStatus !== "DELETE") {
            if (!validateForm()) return;
        }

        const formDataToSend = new FormData();
        formDataToSend.append('user_id', getUserDetails("Id"));
        formDataToSend.append('branch_id', getUserDetails("branchId"));

        if (postStatus !== "DELETE") {
            formDataToSend.append('reminder_type', formData.reminder_type);
            formDataToSend.append('days_offset', formData.days_offset);
            formDataToSend.append('message_template', formData.message_template);
            formDataToSend.append('send_email', formData.send_email ? 1 : 0);
            formDataToSend.append('send_sms', formData.send_sms ? 1 : 0);
            formDataToSend.append('is_active', formData.is_active ? 1 : 0);
            formDataToSend.append('reminder_time', formData.reminder_time);
            formDataToSend.append('notes', formData.notes || '');
        }

        if (postStatus === "UPDATE" || postStatus === "DELETE") {
            formDataToSend.append('updateId', updateId);
        }

        try {
            let result;
            if (postStatus === "ADD") {
                result = await apiService.create(APIReminderRuleStore, formDataToSend);
            } else if (postStatus === "UPDATE") {
                result = await apiService.update(APIReminderRuleUpdate, formDataToSend);
            } else if (postStatus === "DELETE") {
                result = await apiService.delete(APIReminderRuleDelete, formDataToSend);
            }

            if (result && result.success) {
                showToast("Success", result.message, "success");
                handleCloseAdd();
                handleCloseDelete();
                fetchRules();
                fetchStatistics();
            }
        } catch (error) {
            console.error("API Error:", error);
        }
    };

    const getReminderTypeColor = (type) => {
        const option = reminderTypeOptions.find(opt => opt.id === type);
        return option?.color || 'default';
    };

    const getReminderTypeIcon = (type) => {
        const option = reminderTypeOptions.find(opt => opt.id === type);
        return option?.icon || <NotificationsNone />;
    };

    const getReminderTypeText = (type) => {
        const option = reminderTypeOptions.find(opt => opt.id === type);
        return option ? option.name : type;
    };

    const getDeliveryStatusColor = (status) => {
        const option = deliveryStatusOptions.find(opt => opt.id === status);
        return option?.color || 'default';
    };

    const getDeliveryStatusIcon = (status) => {
        const option = deliveryStatusOptions.find(opt => opt.id === status);
        return option?.icon || <Pending />;
    };

    const getDeliveryStatusText = (status) => {
        const option = deliveryStatusOptions.find(opt => opt.id === status);
        return option ? option.name : status;
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-UG', {
            style: 'currency',
            currency: 'UGX',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount);
    };

    if (permissionLoading) {
        return <LoadingState message="Loading permissions..." variant="medical" size="large" fullPage />;
    }

    if (loading) {
        return (
            <LoadingState
                message="Loading Reminder Data..."
                variant="medical"
                size="large"
                fullPage
            />
        );
    }

    if (error) {
        return (
            <ErrorState
                error={error}
                onRetry={() => { fetchRules(); fetchLogs(); fetchStatistics(); }}
                title="Unable to Load Reminder Data"
                variant="medical"
                fullPage
                retryText="Retry Loading"
            />
        );
    }

    return (
        <Container maxWidth="xl" sx={{ py: 3 }}>
            {/* Statistics Cards */}
            {statistics && (
                <Grid container spacing={3} sx={{ mb: 3 }}>
                    <Grid item xs={12} sm={6} md={3}>
                        <Paper elevation={2} sx={{ p: 2, borderRadius: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Box>
                                    <Typography variant="h6" color="text.secondary">Total Reminders</Typography>
                                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: theme.palette.primary.main }}>
                                        {statistics.total_reminders || 0}
                                    </Typography>
                                </Box>
                                <Avatar sx={{ bgcolor: theme.palette.primary.light, width: 56, height: 56 }}>
                                    <NotificationsActive sx={{ fontSize: 32 }} />
                                </Avatar>
                            </Box>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Paper elevation={2} sx={{ p: 2, borderRadius: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Box>
                                    <Typography variant="h6" color="text.secondary">Sent Successfully</Typography>
                                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: theme.palette.success.main }}>
                                        {statistics.sent_count || 0}
                                    </Typography>
                                </Box>
                                <Avatar sx={{ bgcolor: theme.palette.success.light, width: 56, height: 56 }}>
                                    <CheckCircle sx={{ fontSize: 32 }} />
                                </Avatar>
                            </Box>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Paper elevation={2} sx={{ p: 2, borderRadius: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Box>
                                    <Typography variant="h6" color="text.secondary">Failed</Typography>
                                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: theme.palette.error.main }}>
                                        {statistics.failed_count || 0}
                                    </Typography>
                                </Box>
                                <Avatar sx={{ bgcolor: theme.palette.error.light, width: 56, height: 56 }}>
                                    <ErrorIcon sx={{ fontSize: 32 }} />
                                </Avatar>
                            </Box>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Paper elevation={2} sx={{ p: 2, borderRadius: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Box>
                                    <Typography variant="h6" color="text.secondary">Active Rules</Typography>
                                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: theme.palette.warning.main }}>
                                        {statistics.active_rules || 0}
                                    </Typography>
                                </Box>
                                <Avatar sx={{ bgcolor: theme.palette.warning.light, width: 56, height: 56 }}>
                                    <Rule sx={{ fontSize: 32 }} />
                                </Avatar>
                            </Box>
                        </Paper>
                    </Grid>
                </Grid>
            )}

            {/* Action Buttons */}
            <Paper elevation={2} sx={{ p: 3, mb: 3, borderRadius: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                    <Typography variant="h6" sx={{
                        fontWeight: 'bold',
                        color: theme.palette.primary.main,
                        flexShrink: 0
                    }}>
                        Automated Rent Reminders
                    </Typography>

                    <Box sx={{ display: 'flex', gap: 1, flexShrink: 0 }}>
                        {hasPermission('ADD') && (
                            <Button
                                variant="contained"
                                color="warning"
                                startIcon={<AddIcon />}
                                onClick={handleOpenAdd}
                                sx={{ textTransform: 'none', borderRadius: '8px' }}
                            >
                                Add Reminder Rule
                            </Button>
                        )}
                        
                        {hasPermission('EDIT') && (
                            <>
                                <Button
                                    variant="contained"
                                    color="success"
                                    startIcon={<Send />}
                                    onClick={handleSendNow}
                                    disabled={sendingNow}
                                    sx={{ textTransform: 'none', borderRadius: '8px' }}
                                >
                                    {sendingNow ? <CircularProgress size={24} /> : 'Send Now'}
                                </Button>
                                <Button
                                    variant="contained"
                                    color="info"
                                    startIcon={<EmailIcon />}
                                    onClick={handleOpenTestDialog}
                                    sx={{ textTransform: 'none', borderRadius: '8px' }}
                                >
                                    Test Reminder
                                </Button>
                            </>
                        )}
                        
                        {hasPermission('VIEW') && (
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<FilterIcon />}
                                onClick={handlefilterOptions}
                                sx={{ textTransform: 'none', borderRadius: '8px' }}
                            >
                                View Options
                            </Button>
                        )}
                        
                        {hasPermission('EXPORT') && (
                            <Button
                                variant="contained"
                                color="info"
                                startIcon={<GetApp />}
                                onClick={handleExportClick}
                                sx={{ textTransform: 'none', borderRadius: '8px' }}
                            >
                                Export Logs
                            </Button>
                        )}
                        
                        <Button
                            variant="outlined"
                            color="info"
                            startIcon={<RefreshIcon />}
                            onClick={() => {
                                fetchRules();
                                fetchLogs();
                                fetchStatistics();
                            }}
                            sx={{ textTransform: 'none', borderRadius: '8px' }}
                        >
                            Refresh
                        </Button>
                    </Box>

                    <Paper sx={{
                        width: '300px',
                        p: '2px 8px',
                        display: 'flex',
                        alignItems: 'center',
                        marginLeft: 'auto',
                        borderRadius: '8px',
                        background: theme.palette.primary.light
                    }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Search logs..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            InputProps={{
                                startAdornment: <Search sx={{ mr: 1, color: 'white' }} />,
                                sx: {
                                    '& fieldset': { border: 'none' },
                                    fontSize: '0.875rem',
                                    color: 'white',
                                    '& input': {
                                        color: 'white',
                                        '&::placeholder': {
                                            color: 'rgba(255, 255, 255, 0.7)',
                                            opacity: 1
                                        }
                                    }
                                }
                            }}
                            size="small"
                        />
                    </Paper>
                </Box>
            </Paper>

            {/* Tabs */}
            <Paper elevation={2} sx={{ borderRadius: 3, overflow: 'hidden' }}>
                <Tabs value={activeTab} onChange={(e, v) => setActiveTab(v)} sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}>
                    <Tab label="Reminder Rules" icon={<Rule />} iconPosition="start" />
                    <Tab label="Reminder Logs" icon={<HistoryIcon />} iconPosition="start" />
                </Tabs>

                {/* Rules Tab */}
                {activeTab === 0 && (
                    <Box sx={{ p: 2 }}>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow sx={{
                                        backgroundColor: theme.palette.primary.main,
                                        '& th': {
                                            color: 'white',
                                            fontWeight: 'bold',
                                            fontSize: '0.95rem'
                                        }
                                    }}>
                                        <TableCell>#</TableCell>
                                        <TableCell>Reminder Type</TableCell>
                                        <TableCell>Days Offset</TableCell>
                                        <TableCell>Reminder Time</TableCell>
                                        <TableCell>Channels</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell>Last Modified</TableCell>
                                        <TableCell align="center">Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredRules.map((record, index) => (
                                        <TableRow key={record.id || index} hover>
                                            <TableCell>{index + 1}</TableCell>
                                            <TableCell>
                                                <Chip
                                                    icon={getReminderTypeIcon(record.reminder_type)}
                                                    label={getReminderTypeText(record.reminder_type)}
                                                    color={getReminderTypeColor(record.reminder_type)}
                                                    size="small"
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <Typography variant="body2">
                                                    {record.days_offset < 0 ? `${Math.abs(record.days_offset)} days before` :
                                                     record.days_offset > 0 ? `${record.days_offset} days after` :
                                                     'On due date'}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>{record.reminder_time || '09:00'}</TableCell>
                                            <TableCell>
                                                <Stack direction="row" spacing={0.5}>
                                                    {record.send_email && (
                                                        <Chip icon={<EmailIcon />} label="Email" size="small" color="primary" variant="outlined" />
                                                    )}
                                                    {record.send_sms && (
                                                        <Chip icon={<Sms />} label="SMS" size="small" color="success" variant="outlined" />
                                                    )}
                                                </Stack>
                                            </TableCell>
                                            <TableCell>
                                                <Chip
                                                    icon={record.is_active ? <CheckCircle /> : <Cancel />}
                                                    label={record.is_active ? 'Active' : 'Inactive'}
                                                    color={record.is_active ? 'success' : 'default'}
                                                    size="small"
                                                />
                                            </TableCell>
                                            <TableCell>{formatCreatedAtDate(record.updated_at)}</TableCell>
                                            <TableCell align="center">
                                                {hasPermission('VIEW') && (
                                                    <Tooltip title="View Details">
                                                        <IconButton onClick={() => handleOpenView(record)} color="primary">
                                                            <ViewIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                                {hasPermission('EDIT') && (
                                                    <Tooltip title="Edit">
                                                        <IconButton onClick={() => handleOpenEdit(record)} color="secondary">
                                                            <EditIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                                {hasPermission('DELETE') && (
                                                    <Tooltip title="Delete">
                                                        <IconButton onClick={() => handleOpenDelete(record)} color="error">
                                                            <Delete />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {filteredRules.length === 0 && (
                            <Box sx={{ textAlign: 'center', py: 8 }}>
                                <Rule sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
                                <Typography variant="h6">No reminder rules found</Typography>
                                <Typography variant="body2">Click "Add Reminder Rule" to create one</Typography>
                            </Box>
                        )}
                    </Box>
                )}

                {/* Logs Tab */}
                {activeTab === 1 && (
                    <Box>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow sx={{
                                        backgroundColor: theme.palette.primary.main,
                                        '& th': {
                                            color: 'white',
                                            fontWeight: 'bold',
                                            fontSize: '0.95rem'
                                        }
                                    }}>
                                        <TableCell>#</TableCell>
                                        <TableCell>Tenant</TableCell>
                                        <TableCell>Channel</TableCell>
                                        <TableCell>Reminder Date</TableCell>
                                        <TableCell>Message Preview</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell align="center">Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredLogs.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((record, index) => (
                                        <TableRow key={record.id || index} hover>
                                            <TableCell>
                                                <Chip label={page * rowsPerPage + index + 1} color="primary" size="small" />
                                            </TableCell>
                                            <TableCell>
                                                <Box>
                                                    <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                                        {record.tenant_name}
                                                    </Typography>
                                                    <Typography variant="caption" color="text.secondary">
                                                        {record.tenant_phone}
                                                    </Typography>
                                                </Box>
                                            </TableCell>
                                            <TableCell>
                                                <Chip
                                                    icon={record.channel === 'email' ? <EmailIcon /> : <Sms />}
                                                    label={record.channel === 'email' ? 'Email' : 'SMS'}
                                                    size="small"
                                                    color={record.channel === 'email' ? 'primary' : 'success'}
                                                    variant="outlined"
                                                />
                                            </TableCell>
                                            <TableCell>
                                                {new Date(record.reminder_date).toLocaleString()}
                                            </TableCell>
                                            <TableCell>
                                                <Tooltip title={record.message_sent}>
                                                    <Typography variant="body2" sx={{
                                                        maxWidth: 300,
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap'
                                                    }}>
                                                        {record.message_sent}
                                                    </Typography>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell>
                                                <Chip
                                                    icon={getDeliveryStatusIcon(record.delivery_status)}
                                                    label={getDeliveryStatusText(record.delivery_status)}
                                                    color={getDeliveryStatusColor(record.delivery_status)}
                                                    size="small"
                                                />
                                            </TableCell>
                                            <TableCell align="center">
                                                {hasPermission('VIEW') && (
                                                    <Tooltip title="View Details">
                                                        <IconButton onClick={() => handleOpenView(record)} color="primary">
                                                            <ViewIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                                {hasPermission('PRINT') && (
                                                    <Tooltip title="Print Log">
                                                        <IconButton onClick={() => handlePrintLog(record)} color="info">
                                                            <PrintIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            component="div"
                            count={filteredLogs.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            sx={{ mt: 2 }}
                        />
                        {filteredLogs.length === 0 && (
                            <Box sx={{ textAlign: 'center', py: 8 }}>
                                <HistoryIcon sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
                                <Typography variant="h6">No reminder logs found</Typography>
                                <Typography variant="body2">Reminders will appear here when sent</Typography>
                            </Box>
                        )}
                    </Box>
                )}
            </Paper>

            {/* Export Menu */}
            <Menu
                anchorEl={exportAnchorEl}
                open={Boolean(exportAnchorEl)}
                onClose={handleExportClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <MenuItem onClick={handleExportExcel} sx={{ gap: 1 }}>
                    <TableChart fontSize="small" color="success" />
                    Export to Excel (.xlsx)
                </MenuItem>
                <MenuItem onClick={handleExportPDF} sx={{ gap: 1 }}>
                    <PictureAsPdf fontSize="small" color="error" />
                    Export to PDF (.pdf)
                </MenuItem>
            </Menu>

            {/* Filter Options Dialog - Prevent closing on outside click */}
            <Dialog 
                open={filterOptions} 
                TransitionComponent={Transition} 
                fullWidth 
                maxWidth="sm" 
                onClose={(e, reason) => { if (reason === 'backdropClick') return; handleCloseOptions(); }}
                disableEscapeKeyDown
            >
                <DialogTitle sx={{ textAlign: 'center' }}>Filter Options</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, p: 2 }}>
                        <Button variant="outlined" color="primary" startIcon={<RefreshIcon />} onClick={clearFilters}>
                            Show All
                        </Button>
                        <Divider>OR</Divider>
                        <Typography variant="subtitle1" sx={{ textAlign: 'center' }}>Filter Logs</Typography>
                        <Box>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel>Delivery Status</InputLabel>
                                    <Select name="delivery_status" value={filters.delivery_status} onChange={handleFilterChange} label="Delivery Status">
                                        <MenuItem value="">All Status</MenuItem>
                                        {deliveryStatusOptions.map(item => (
                                            <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid><br/>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel>Channel</InputLabel>
                                    <Select name="channel" value={filters.channel} onChange={handleFilterChange} label="Channel">
                                        <MenuItem value="">All Channels</MenuItem>
                                        {channelOptions.map(item => (
                                            <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid><br/>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel>Tenant</InputLabel>
                                    <Select name="tenant_id" value={filters.tenant_id} onChange={handleFilterChange} label="Tenant">
                                        <MenuItem value="">All Tenants</MenuItem>
                                        {tenants.map(tenant => (
                                            <MenuItem key={tenant.id} value={tenant.id}>{tenant.full_name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth label="Date From" name="date_from" type="date" value={filters.date_from} onChange={handleFilterChange} InputLabelProps={{ shrink: true }} />
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth label="Date To" name="date_to" type="date" value={filters.date_to} onChange={handleFilterChange} InputLabelProps={{ shrink: true }} />
                            </Grid>
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button color="error" onClick={handleCloseOptions} variant="contained">Close</Button>
                    <Button onClick={applyFilters} color="primary" variant="contained">Apply Filters</Button>
                </DialogActions>
            </Dialog>

            {/* Add/Edit Rule Dialog - Prevent closing on outside click */}
            <Dialog 
                open={openAdd} 
                onClose={(e, reason) => { if (reason === 'backdropClick') return; handleCloseAdd(); }} 
                TransitionComponent={Transition} 
                fullWidth 
                maxWidth="sm" 
                scroll="paper"
                disableEscapeKeyDown
            >
                <DialogTitle sx={{ textAlign: 'center' }}>
                    <b>{postStatus === "ADD" ? "Add Reminder Rule" : "Edit Reminder Rule"}</b>
                </DialogTitle>
                <DialogContent>
                    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
                        <Box>
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 1 }}>
                                    Rule Configuration
                                </Typography>
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth required>
                                    <InputLabel>Reminder Type *</InputLabel>
                                    <Select name="reminder_type" value={formData.reminder_type} onChange={handleInputChange} label="Reminder Type *">
                                        {reminderTypeOptions.map(item => (
                                            <MenuItem key={item.id} value={item.id}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    {item.icon} {item.name}
                                                </Box>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth label="Days Offset" name="days_offset" type="number"
                                    value={formData.days_offset} onChange={handleInputChange}
                                    helperText="Negative = before due date, Positive = after due date, 0 = on due date"
                                    InputProps={{ startAdornment: <InputAdornment position="start"><Schedule /></InputAdornment> }}
                                />
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth label="Reminder Time" name="reminder_time" type="time" value={formData.reminder_time} onChange={handleInputChange} InputLabelProps={{ shrink: true }} />
                            </Grid><br/>
                            <Grid item xs={12}>
                                <FormControlLabel control={<Switch name="is_active" checked={formData.is_active} onChange={handleInputChange} color="primary" />} label="Active" />
                            </Grid><br/>
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 1, mt: 2 }}>
                                    Delivery Channels
                                </Typography>
                            </Grid><br/>
                            <Grid item xs={12}>
                                <FormControlLabel control={<Switch name="send_email" checked={formData.send_email} onChange={handleInputChange} color="primary" />} label="Send Email" />
                                <FormControlLabel control={<Switch name="send_sms" checked={formData.send_sms} onChange={handleInputChange} color="success" />} label="Send SMS" sx={{ ml: 3 }} />
                            </Grid><br/>
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 1, mt: 2 }}>
                                    Message Template
                                </Typography>
                                <Typography variant="caption" color="text.secondary" display="block" gutterBottom>
                                    Available placeholders: {'{tenant_name}'}, {'{rent_amount}'}, {'{apartment_number}'}, {'{due_date}'}, {'{days}'}, {'{company_name}'}
                                </Typography>
                                <TextField
                                    fullWidth label="Message Template *" name="message_template" value={formData.message_template} onChange={handleInputChange}
                                    multiline rows={8} required placeholder="Enter your message template here..."
                                />
                            </Grid><br/>
                            <Grid item xs={12}>
                                <TextField fullWidth label="Notes" name="notes" value={formData.notes} onChange={handleInputChange} multiline rows={3} />
                            </Grid>
                        </Box>
                        <DialogActions sx={{ mt: 3, px: 0 }}>
                            <Button color="error" onClick={handleCloseAdd} variant="contained">Cancel</Button>
                            <Button type="submit" color="primary" variant="contained">
                                {postStatus === "ADD" ? "Create Rule" : "Update Rule"}
                            </Button>
                        </DialogActions>
                    </Box>
                </DialogContent>
            </Dialog>

            {/* Test Reminder Dialog - Prevent closing on outside click */}
            <Dialog 
                open={testDialogOpen} 
                onClose={(e, reason) => { if (reason === 'backdropClick') return; handleCloseTestDialog(); }} 
                TransitionComponent={Transition} 
                fullWidth 
                maxWidth="sm"
                disableEscapeKeyDown
            >
                <DialogTitle sx={{ textAlign: 'center' }}>Test Reminder</DialogTitle>
                <DialogContent>
                    <Box sx={{ p: 2 }}>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel>Select Tenant</InputLabel>
                            <Select value={testTenantId} onChange={(e) => setTestTenantId(e.target.value)} label="Select Tenant">
                                <MenuItem value="">Select a tenant</MenuItem>
                                {tenants.map(tenant => (
                                    <MenuItem key={tenant.id} value={tenant.id}>{tenant.full_name} - {tenant.phone_number}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <TextField
                            fullWidth label="Custom Message (Optional)" value={testMessage} onChange={(e) => setTestMessage(e.target.value)}
                            multiline rows={4} placeholder="Leave empty to use default template based on rule"
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button color="error" onClick={handleCloseTestDialog} variant="contained">Cancel</Button>
                    <Button onClick={handleTestSend} color="primary" variant="contained">Send Test</Button>
                </DialogActions>
            </Dialog>

            {/* View Dialog - Prevent closing on outside click */}
            <Dialog 
                open={openView} 
                onClose={(e, reason) => { if (reason === 'backdropClick') return; handleCloseView(); }} 
                TransitionComponent={Transition} 
                fullWidth 
                maxWidth="md"
                disableEscapeKeyDown
            >
                <DialogTitle sx={{ textAlign: 'center' }}><b>{activeTab === 0 ? "Reminder Rule Details" : "Reminder Log Details"}</b></DialogTitle>
                <DialogContent>
                    {selectedRecord && activeTab === 0 && (
                        <Box sx={{ p: 2 }}>
                            <Box>
                                <Grid item xs={12}><Typography variant="h6" color="primary">Rule Information</Typography></Grid><br/>
                                <Grid item xs={12} sm={6}><Typography variant="subtitle2"><b>Reminder Type:</b> {getReminderTypeText(selectedRecord.reminder_type)}</Typography></Grid><br/>
                                <Grid item xs={12} sm={6}><Typography variant="subtitle2"><b>Days Offset:</b> {selectedRecord.days_offset}</Typography></Grid><br/>
                                <Grid item xs={12} sm={6}><Typography variant="subtitle2"><b>Reminder Time:</b> {selectedRecord.reminder_time || '09:00'}</Typography></Grid><br/>
                                <Grid item xs={12} sm={6}><Typography variant="subtitle2"><b>Status:</b> <Chip label={selectedRecord.is_active ? 'Active' : 'Inactive'} color={selectedRecord.is_active ? 'success' : 'default'} size="small" /></Typography></Grid><br/>
                                <Grid item xs={12}><Typography variant="subtitle2"><b>Channels:</b> {selectedRecord.send_email ? 'Email ' : ''}{selectedRecord.send_sms ? 'SMS' : ''}</Typography></Grid><br/>
                                <Grid item xs={12}><Typography variant="subtitle2"><b>Message Template:</b></Typography><Paper variant="outlined" sx={{ p: 2, mt: 1, bgcolor: '#f5f5f5' }}><Typography variant="body2" style={{ whiteSpace: 'pre-wrap' }}>{selectedRecord.message_template}</Typography></Paper></Grid><br/>
                                {selectedRecord.notes && <Grid item xs={12}><Typography variant="subtitle2"><b>Notes:</b> {selectedRecord.notes}</Typography></Grid>}<br/>
                                <Grid item xs={12}><Typography variant="h6" color="primary" sx={{ mt: 2 }}>System Information</Typography></Grid><br/>
                                <Grid item xs={12} sm={6}><Typography variant="subtitle2"><b>Created:</b> {formatCreatedAtDate(selectedRecord.created_at)}</Typography></Grid><br/>
                                <Grid item xs={12} sm={6}><Typography variant="subtitle2"><b>Last Updated:</b> {formatCreatedAtDate(selectedRecord.updated_at)}</Typography></Grid><br/>
                            </Box>
                        </Box>
                    )}
                    {selectedRecord && activeTab === 1 && (
                        <Box sx={{ p: 2 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}><Typography variant="h6" color="primary">Log Information</Typography></Grid>
                                <Grid item xs={12} sm={6}><Typography variant="subtitle2"><b>Tenant:</b> {selectedRecord.tenant_name}</Typography></Grid>
                                <Grid item xs={12} sm={6}><Typography variant="subtitle2"><b>Channel:</b> {selectedRecord.channel === 'email' ? 'Email' : 'SMS'}</Typography></Grid>
                                <Grid item xs={12} sm={6}><Typography variant="subtitle2"><b>Reminder Date:</b> {new Date(selectedRecord.reminder_date).toLocaleString()}</Typography></Grid>
                                <Grid item xs={12} sm={6}><Typography variant="subtitle2"><b>Status:</b> <Chip icon={getDeliveryStatusIcon(selectedRecord.delivery_status)} label={getDeliveryStatusText(selectedRecord.delivery_status)} color={getDeliveryStatusColor(selectedRecord.delivery_status)} size="small" /></Typography></Grid>
                                <Grid item xs={12}><Typography variant="subtitle2"><b>Message Sent:</b></Typography><Paper variant="outlined" sx={{ p: 2, mt: 1, bgcolor: '#f5f5f5' }}><Typography variant="body2" style={{ whiteSpace: 'pre-wrap' }}>{selectedRecord.message_sent}</Typography></Paper></Grid>
                                {selectedRecord.error_message && <Grid item xs={12}><Alert severity="error"><Typography variant="subtitle2"><b>Error:</b> {selectedRecord.error_message}</Typography></Alert></Grid>}
                                <Grid item xs={12}><Typography variant="h6" color="primary" sx={{ mt: 2 }}>System Information</Typography></Grid>
                                <Grid item xs={12}><Typography variant="subtitle2"><b>Created:</b> {formatCreatedAtDate(selectedRecord.created_at)}</Typography></Grid>
                            </Grid>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions><Button color="error" onClick={handleCloseView} variant="contained">Close</Button></DialogActions>
            </Dialog>

            {/* Delete Confirmation Dialog - Prevent closing on outside click */}
            <Dialog 
                open={openDelete} 
                onClose={(e, reason) => { if (reason === 'backdropClick') return; handleCloseDelete(); }} 
                TransitionComponent={Transition}
                disableEscapeKeyDown
            >
                <DialogTitle sx={{ textAlign: 'center' }}>Delete Reminder Rule</DialogTitle>
                <DialogContent>
                    <Typography variant="body1" sx={{ textAlign: 'center', mb: 2 }}>Are you sure you want to delete this reminder rule?</Typography>
                    {selectedRecord && <Typography variant="h6" sx={{ textAlign: 'center' }}>{getReminderTypeText(selectedRecord.reminder_type)} - {selectedRecord.days_offset} days</Typography>}
                    <Typography variant="body2" color="error" sx={{ textAlign: 'center', mt: 2 }}>Warning: This action cannot be undone!</Typography>
                </DialogContent>
                <DialogActions><Button color="error" onClick={handleCloseDelete} variant="contained">Cancel</Button><Button onClick={handleSubmit} color="primary" variant="contained">Confirm Delete</Button></DialogActions>
            </Dialog>

            <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
                <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>{snackbar.message}</Alert>
            </Snackbar>
        </Container>
    );
};

export default RentReminder;